import { sagas as dashboardSagas } from '../features/Dashboard/store/sagas'
import { sagas as wireSagas } from '../features/MoneyMovement/store/sagas'

export const sagas = [...dashboardSagas, ...wireSagas]
